import { render } from "./Index_index_en_m.vue?vue&type=template&id=5f3932ec&scoped=true"
import script from "./Index_index_en_m.vue?vue&type=script&lang=js"
export * from "./Index_index_en_m.vue?vue&type=script&lang=js"

import "./Index_index_en_m.vue?vue&type=style&index=0&id=5f3932ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f3932ec"

export default script